"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.posterImageStyles = void 0;
exports.posterImageStyles = {
    image: {
        height: "inherit",
        width: "100%",
        objectFit: "cover",
    },
    stockImageWrapper: {
        height: "inherit",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    cameraIcon: {
        width: "30%",
    },
};
//# sourceMappingURL=styles.js.map